import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { grayBorders, textColor, toqueColor } from '../../theme/colors'
import { CenterState } from '../../context/SeaWater/ControlServices/types'
import { CloseIcon } from '../Svg'

interface Item {
  name: string
  id: number
  state?: CenterState
}
interface Props {
  item: Item
  onPress: (item: Item) => void
  isSelected: boolean
  circle?: boolean
  closeIcon?: boolean
}

export const OptionsItem = ({ item, onPress, isSelected, closeIcon }: Props) => (
  <TouchableOpacity
    style={[
      styles.container,
      {
        borderColor: isSelected ? toqueColor : grayBorders,
        backgroundColor: isSelected ? toqueColor : 'transparent',
      },
    ]}
    onPress={() => onPress(item)}
  >
    <View style={{ overflow: 'visible', alignItems: 'center', flexDirection: 'row', gap: 4 }}>
      <Text style={{ color: isSelected ? 'white' : textColor }}>{item.name}</Text>
      {closeIcon && <CloseIcon height={20} width={20} />}
    </View>
  </TouchableOpacity>
)

const styles = StyleSheet.create({
  container: {
    padding: 12,
    borderWidth: 1,
    borderRadius: 8,
    marginRight: 10,
    marginTop: 10,
    height: 42,
  },
})
